import React from 'react'
import { object, string } from 'prop-types'
import ContactCenterCustomerNumber from './contactCenterCustomerNumber.jsx'

class ContactCenterPhoneNumber extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      agentData: this.props.agentData
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      agentData: nextProps.agentData
    })
  }

  getPhoneNumber () {
    const { agents, agentData, productType } = this.props
    if (agents[productType]) return agents[productType]
    if (agentData.DDI) return agentData.DDI
    return agents.switchboardNumber
  }

  render () {
    const { settings, agentData, productType, id, agents } = this.props
    return (
      <span id={id}>
        <ContactCenterCustomerNumber agents={agents} settings={settings} agentData={agentData} type={productType} phoneNumber={this.getPhoneNumber()} />
      </span>
    )
  }
}

ContactCenterPhoneNumber.propTypes = {
  agents: object,
  agentData: object,
  productType: string,
  id: string
}

export default ContactCenterPhoneNumber



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/contactCentre/contactCentrePhoneNumber.jsx